// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d76430d4","455":"bc6c4299","977":"edfe829c"}[chunkId] + ".chunk.js";
};